import { Row } from "antd";
import { useTranslation } from "react-i18next";
import { Headline } from "sunday-component";
import { Container, VideoContainer } from "./VideoSection.styled";

export const VideoSection = () => {
  const { t } = useTranslation("affiliate");

  const videoUrls = [
    "https://www.youtube.com/embed/jr7MHKQSGKw?si=g4JEvoV8uSE5sJ4n",
  ];
  return (
    <Container>
      <Headline level={6}>{t("videoSection.title")}</Headline>
      <Row gutter={[16, 16]}>
        {videoUrls.map((url) => (
          <VideoContainer xs={24} sm={12}>
            <iframe
              width="100%"
              height="100%"
              src={url}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </VideoContainer>
        ))}
      </Row>
    </Container>
  );
};
